/* Useit Maison — theme scripts (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------ Money */
  theme.formatMoney = function (c) { return formatMoney(c); };
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount}} €';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    function fmt(n, precision, thousands, decimal) {
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var value;
    switch (type) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ------------------------------------------------------------------ Toast */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------------------------------------------------------- Drawers */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = d.querySelector('input[type="search"], .drawer__panel button, .drawer__panel a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); return; }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && document.getElementById('CartDrawer') && !document.querySelector('[data-cart-page]')) {
      e.preventDefault(); openDrawer('CartDrawer');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ------------------------------------------------------------------- Cart */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  // Wallet buttons (Apple Pay, Shop Pay…) are initialised once by Shopify: keep that node alive
  // and move it in and out of the refreshed drawer markup instead of re-rendering it.
  function parkExpress() {
    var ex = $('[data-express]'), drawer = document.getElementById('CartDrawer');
    if (ex && drawer && ex.parentNode !== drawer) drawer.appendChild(ex);
  }
  function placeExpress() {
    var ex = $('[data-express]'), slot = $('[data-express-slot]');
    if (!ex) return;
    if (slot) { slot.appendChild(ex); ex.hidden = false; }
    else { parkExpress(); ex.hidden = true; }
  }
  placeExpress();

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) {
      parkExpress();
      current.innerHTML = fresh.innerHTML;
      placeExpress();
      if (window.UseitDates) window.UseitDates();
      if (window.UseitSalam) window.UseitSalam();
    }
  }

  function cartRequest(url, body) {
    var hasDrawer = !!document.getElementById('CartDrawer');
    if (hasDrawer) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  function refreshCartCount() {
    return fetch((theme.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); return c; });
  }

  // Quick add (universe pages): one-tap add to the drawer, plain form post otherwise
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form || document.body.dataset.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.classList.add('is-loading');
    cartRequest(theme.routes.cartAdd || '/cart/add.js', { items: [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }] })
      .then(function (res) {
        if (res.sections) renderDrawer(res.sections['cart-drawer']);
        return refreshCartCount();
      })
      .then(function () { openDrawer('CartDrawer'); })
      .catch(function (err) { toast((err && (err.description || err.message)) || theme.strings.error || 'Error'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  // Optional gift wrap
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gift-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.cart-gift'); if (box) box.classList.add('is-loading');
    cartRequest(theme.routes.cartAdd || '/cart/add.js', { items: [{ id: parseInt(btn.getAttribute('data-gift-add'), 10), quantity: 1 }] })
      .then(function (res) {
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        if (res.sections) renderDrawer(res.sections['cart-drawer']);
        return refreshCartCount();
      })
      .catch(function (err) {
        if (box) box.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || theme.strings.error || 'Error');
      });
  });

  // Gift message saved as the order note
  var noteTimer;
  document.addEventListener('input', function (e) {
    var t = e.target.closest('[data-cart-note]');
    if (!t) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch((theme.routes.cart || '/cart') + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: t.value })
      });
    }, 500);
  });

  // Line quantity changes (drawer + cart page)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line-change'), 10);
    var qty = Math.max(0, parseInt(btn.getAttribute('data-qty'), 10));
    var row = btn.closest('.cart-line');
    if (row) row.classList.add('is-loading');
    cartRequest(theme.routes.cartChange || '/cart/change.js', { line: line, quantity: qty })
      .then(function (cart) {
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        updateCount(cart.item_count);
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
      })
      .catch(function (err) {
        if (row) row.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || theme.strings.error || 'Error');
      });
  });

  /* ------------------------------------------------------------ Product form */
  function initProduct(section) {
    if (!section || section.dataset.ready) return;
    section.dataset.ready = '1';
    var jsonEl = $('[data-product-json]', section);
    var form = $('[data-product-form]', section) || $('form.product-form', section) || $('form[action*="/cart/add"]', section);
    if (!jsonEl || !form) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants || [];
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-to-cart]', form);
    var addLabel = $('[data-add-label]', form);
    var stock = $('[data-stock]', form);
    var errorEl = $('[data-form-error]', form);

    function selectedOptions() {
      return $$('.variant-picker', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function markAvailability() {
      var sel = selectedOptions();
      $$('.variant-picker', form).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = sel.slice(); test[idx] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function onChange() {
      var sel = selectedOptions();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      $$('.variant-picker', form).forEach(function (fs, i) {
        var out = $('[data-option-value]', fs); if (out) out.textContent = sel[i] || '';
      });
      markAvailability();
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = theme.strings.unavailable;
        if (stock) stock.classList.add('is-hidden');
        return;
      }
      idInput.value = v.id;
      document.dispatchEvent(new CustomEvent('useit:variant', { detail: { variant: v, section: section } }));
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (stock) stock.classList.toggle('is-hidden', !v.available);

      var cur = $('[data-price-current]', section);
      var cmp = $('[data-price-compare]', section);
      var priceWrap = $('[data-price]', section);
      if (cur) cur.textContent = formatMoney(v.price);
      if (cmp) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        cmp.hidden = !sale;
        cmp.textContent = sale ? formatMoney(v.compare_at_price) : '';
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
      }
      if (v.featured_media) showMedia(section, String(v.featured_media.id));
      var sv = $('[data-sticky-variant]', section); if (sv) sv.textContent = v.title;
      var sp = $('[data-sticky-price]', section); if (sp) sp.textContent = formatMoney(v.price);
      var sb = $('[data-sticky-add]', section); if (sb) sb.disabled = !v.available;
      var sl = $('[data-sticky-label]', section); if (sl) sl.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      var ds = document.querySelector('[data-details]');
      if (ds && v.featured_media && v.featured_media.preview_image) {
        var base = v.featured_media.preview_image.src;
        $$('[data-details-img]', ds).forEach(function (im) {
          im.removeAttribute('srcset');
          im.src = base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
        });
        var dv = $('[data-details-variant]', ds); if (dv) dv.textContent = v.title;
      }
      var si = $('[data-sticky-img]', section);
      if (si && v.featured_media && v.featured_media.preview_image) si.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      if (history.replaceState && data.url) {
        history.replaceState({}, '', data.url + '?variant=' + v.id);
      }
    }

    $$('.variant-picker input', form).forEach(function (i) { i.addEventListener('change', onChange); });
    markAvailability();

    // Quantity
    var qtyWrap = $('[data-qty]', form);
    if (qtyWrap) {
      var qi = $('input', qtyWrap);
      qtyWrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-minus]')) qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1);
        if (e.target.closest('[data-qty-plus]')) qi.value = (parseInt(qi.value, 10) || 1) + 1;
      });
    }

    // Sticky add-to-cart bar: visible once the main button has scrolled out of view
    var sticky = $('[data-sticky-atc]', section);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    // AJAX add to cart
    form.addEventListener('submit', function (e) {
      if (document.body.dataset.cartType !== 'drawer') return;
      e.preventDefault();
      if (errorEl) errorEl.classList.add('is-hidden');
      addBtn.classList.add('is-loading');
      var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      cartRequest(theme.routes.cartAdd || '/cart/add.js', { items: [{ id: parseInt(idInput.value, 10), quantity: qty }] })
        .then(function (res) {
          if (res.sections) renderDrawer(res.sections['cart-drawer']);
          return refreshCartCount();
        })
        .then(function () { openDrawer('CartDrawer'); })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || theme.strings.error || 'Error';
          if (errorEl) { errorEl.textContent = msg; errorEl.classList.remove('is-hidden'); } else toast(msg);
        })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });
  }

  /* ---------------------------------------------------------------- Gallery */
  function showMedia(scope, id) {
    var slides = $$('.gallery__slide', scope);
    if (!slides.some(function (s) { return s.dataset.mediaId === id; })) return;
    slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
    $$('.gallery__thumb', scope).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === id); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-gallery]'), thumb.dataset.thumb); return; }
    var main = e.target.closest('.gallery__main.is-zoomable');
    if (main) {
      var section = main.closest('[data-product-section]');
      var active = $('.gallery__slide.is-active', main);
      openLightbox(section, active ? active.dataset.mediaId : null);
    }
  });

  /* ---------------------------------------------------------------- Lightbox */
  var lb = null;
  function lbSlides() { return $$('.lightbox__slide', lb); }
  function lbIndex() {
    var t = $('[data-lb-track]', lb);
    return Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
  }
  function lbGo(i, smooth) {
    var t = $('[data-lb-track]', lb), n = lbSlides().length;
    i = (i + n) % n;
    t.scrollTo({ left: i * t.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    lbSync(i);
  }
  function lbSync(i) {
    if (i == null) i = lbIndex();
    var c = $('[data-lb-current]', lb); if (c) c.textContent = i + 1;
    $$('.lightbox__thumb', lb).forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
  }
  function openLightbox(section, mediaId) {
    lb = section && $('[data-lightbox]', section);
    if (!lb) return;
    $$('img[data-src]', lb).forEach(function (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); });
    lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var idx = 0;
    lbSlides().forEach(function (sl, k) { if (sl.dataset.mediaId === String(mediaId)) idx = k; });
    requestAnimationFrame(function () { lbGo(idx, false); });
    var closeBtn = $('[data-lb-close]', lb); if (closeBtn) closeBtn.focus();
  }
  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    lb = null;
  }
  document.addEventListener('click', function (e) {
    if (!lb) return;
    if (e.target.closest('[data-lb-close]')) closeLightbox();
    else if (e.target.closest('[data-lb-prev]')) lbGo(lbIndex() - 1);
    else if (e.target.closest('[data-lb-next]')) lbGo(lbIndex() + 1);
    else if (e.target.closest('[data-lb-go]')) lbGo(parseInt(e.target.closest('[data-lb-go]').dataset.lbGo, 10));
    else if (e.target.classList.contains('lightbox__slide')) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (!lb) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') lbGo(lbIndex() + 1);
    if (e.key === 'ArrowLeft') lbGo(lbIndex() - 1);
  });
  document.addEventListener('scroll', function (e) {
    if (lb && e.target && e.target.matches && e.target.matches('[data-lb-track]')) lbSync();
  }, true);

  /* ------------------------------------------------------------ Card colour swatches */
  function selectSwatch(sw) {
    var card = sw.closest('.card');
    if (!card) return;
    $$('.swatch', card).forEach(function (x) { x.classList.toggle('is-active', x === sw); });
    var img = $('.card__img--primary', card);
    if (img && sw.dataset.img) {
      img.removeAttribute('srcset');
      img.src = sw.dataset.img;
    }
    if (sw.dataset.url) $$('a[href]', card).forEach(function (a) { a.href = sw.dataset.url; });
    var qid = $('.card__quick [name="id"]', card);
    if (qid && sw.dataset.id) {
      qid.value = sw.dataset.id;
      var soldout = sw.hasAttribute('data-soldout');
      var qb = $('.card__quick-btn', card);
      if (qb) qb.disabled = soldout;
      var bn = $('[data-buy-now]', card);
      if (bn) {
        bn.href = bn.href.replace(/\/cart\/\d+:1/, '/cart/' + sw.dataset.id + ':1');
        bn.classList.toggle('is-disabled', soldout);
        bn.textContent = soldout ? theme.strings.soldOut : 'Acheter';
      }
    }
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.card__swatches .swatch');
    if (sw) { e.preventDefault(); selectSwatch(sw); }
  });
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.card__swatches .swatch');
    if (sw && window.matchMedia('(hover: hover)').matches && !sw.closest('.card').querySelector('.card__quick')) selectSwatch(sw);
  });

  /* ------------------------------------------------------------ Welcome popup */
  function initPopup(p) {
    if (!p || p.dataset.ready) return;
    p.dataset.ready = '1';
    var key = 'useit-popup-seen';
    var days = parseInt(p.dataset.days, 10) || 14;
    function open() { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); }
    function close() {
      p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem(key, String(Date.now())); } catch (err) {}
    }
    p.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); close(); }
      var copy = e.target.closest('[data-copy]');
      if (copy) {
        var label = $('[data-copy-label]', copy);
        (navigator.clipboard ? navigator.clipboard.writeText(copy.dataset.copy) : Promise.reject())
          .then(function () { if (label) label.textContent = theme.strings.copied || 'OK'; })
          .catch(function () { if (label) label.textContent = copy.dataset.copy; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && p.classList.contains('is-open')) close(); });

    // Just signed up: show the code right away
    if ($('[data-popup-success]', p)) { open(); try { localStorage.setItem(key, String(Date.now())); } catch (err) {} return; }
    if (p.dataset.designMode === 'true') return;
    if (/\/(cart|checkout|account)/.test(location.pathname)) return;
    var seen = 0;
    try { seen = parseInt(localStorage.getItem(key), 10) || 0; } catch (err) {}
    if (Date.now() - seen < days * 864e5) return;
    setTimeout(function () { if (!$('.drawer.is-open')) open(); }, (parseInt(p.dataset.delay, 10) || 8) * 1000);
  }
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector('[data-popup]'); if (p) { initPopup(p); p.classList.add('is-open'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector('[data-popup]'); if (p) p.classList.remove('is-open');
  });

  /* ------------------------------------------------------------ Predictive search */
  function initPredictive(root) {
    var input = $('[data-predictive-input]', root);
    var box = $('[data-predictive]', root);
    if (!input || !box || input.dataset.ready) return;
    input.dataset.ready = '1';
    var out = $('[data-predictive-results]', box);
    var chips = $('[data-predictive-chips]', box);
    var timer, ctrl;
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function imgUrl(p) {
      var u = (p.featured_image && p.featured_image.url) || p.image || '';
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=360';
    }
    function render(q, products) {
      if (chips) chips.hidden = !!q;
      if (!q) { out.innerHTML = ''; return; }
      if (!products.length) {
        out.innerHTML = '<p class="predictive__empty">' + esc((theme.strings.noResults || '').replace('%s', q)) + '</p>';
        return;
      }
      var html = '<ul class="predictive__grid">' + products.map(function (p) {
        var price = p.price != null ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
        var src = imgUrl(p);
        return '<li><a class="predictive__item" href="' + esc(p.url) + '">' +
          '<span class="predictive__media">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="predictive__title">' + esc(p.title) + '</span>' +
          '<span class="predictive__price">' + esc(price) + '</span></a></li>';
      }).join('') + '</ul>' +
        '<a class="link-underline predictive__all" href="' + esc((theme.routes.search || '/search') + '?type=product&q=' + encodeURIComponent(q)) + '">' +
        esc((theme.strings.viewAllFor || '%s').replace('%s', q)) + '</a>';
      out.innerHTML = html;
    }
    function search(q) {
      q = q.trim();
      if (q.length < 2) { render('', []); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = (theme.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag';
      box.classList.add('is-loading');
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(q, products.filter(function (p) { return (p.tags || []).indexOf('cadeau') === -1; }));
        })
        .catch(function () {})
        .finally(function () { box.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value;
      timer = setTimeout(function () { search(q); }, 220);
    });
    box.addEventListener('click', function (e) {
      var c = e.target.closest('[data-chip]');
      if (c) { input.value = c.dataset.chip; input.focus(); search(input.value); }
    });
  }

  /* ------------------------------------------------------------ Recommendations */
  function initRecos(el) {
    if (!el || el.dataset.ready || !el.dataset.url) return;
    el.dataset.ready = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; observeReveal(el); }
    }).catch(function () {});
  }

  /* ------------------------------------------------------------ Collection filters */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-autosubmit]');
    if (!el) return;
    var form = el.closest('form');
    if (form) form.submit();
  });
  document.addEventListener('click', function (e) {
    $$('details.filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ------------------------------------------------------------ Login / recover toggle */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-recover]');
    if (!t) return;
    e.preventDefault();
    var wrap = t.closest('[data-login]');
    $('[data-login-panel]', wrap).hidden = !$('[data-login-panel]', wrap).hidden;
    $('[data-recover-panel]', wrap).hidden = !$('[data-recover-panel]', wrap).hidden;
  });

  /* ------------------------------------------------------------ Announcement rotation */
  function initAnnouncement(track) {
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var items = $$('.announcement__item', track), i = 0;
    if (items.length < 2) return;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ------------------------------------------------------------ Live watch hands */
  function tickWatches() {
    var watches = $$('.js-live-watch');
    if (!watches.length) return;
    var now = new Date();
    var s = now.getSeconds() + now.getMilliseconds() / 1000;
    var m = now.getMinutes() + s / 60;
    var h = (now.getHours() % 12) + m / 60;
    watches.forEach(function (w) {
      var hh = $('.watch-hand--h', w), mm = $('.watch-hand--m', w), ss = $('.watch-hand--s', w);
      if (hh) hh.setAttribute('transform', 'rotate(' + (h * 30).toFixed(2) + ' 200 200)');
      if (mm) mm.setAttribute('transform', 'rotate(' + (m * 6).toFixed(2) + ' 200 200)');
      if (ss) ss.setAttribute('transform', 'rotate(' + (s * 6).toFixed(2) + ' 200 200)');
      var d = $('.js-watch-date', w); if (d) d.textContent = ('0' + now.getDate()).slice(-2);
    });
  }

  /* ------------------------------------------------------------ Reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;
  function observeReveal(ctx) {
    $$('.reveal:not(.is-in)', ctx).forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  }

  /* ------------------------------------------------------------ Sticky header shadow */
  function onScroll() {
    var h = $('[data-header]');
    if (h) h.classList.toggle('is-scrolled', window.scrollY > 10);
  }

  /* ------------------------------------------------------------ Init */
  function init(ctx) {
    $$('[data-product-section]', ctx).forEach(initProduct);
    $$('[data-recommendations]', ctx).forEach(initRecos);
    $$('.js-announcement', ctx).forEach(initAnnouncement);
    $$('[data-popup]', ctx).forEach(initPopup);
    initPredictive(ctx);
    $$('.gallery__main', ctx).forEach(function (g) {
      var sec = g.closest('[data-product-section]');
      if (g.querySelector('img') && sec && sec.querySelector('[data-lightbox]')) g.classList.add('is-zoomable');
    });
    observeReveal(ctx);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    onScroll();
    tickWatches();
    setInterval(tickWatches, 1000);
  });
  window.addEventListener('scroll', onScroll, { passive: true });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); tickWatches(); });
  document.addEventListener('shopify:section:select', function (e) {
    var d = e.target.querySelector('[data-drawer]');
    if (d && d.id === 'CartDrawer') openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = e.target.querySelector('[data-drawer].is-open');
    if (d) closeDrawer(d);
  });

  /* ------------------------------------------------------ Universe carousel */
  // Swipe between universes; the whole page takes the colours of the one on screen.
  function hexToRgb(hex) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    return [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16); }).join(', ');
  }
  $$('[data-u-carousel]').forEach(function (root) {
    var track = $('[data-u-track]', root);
    var slides = $$('.u-slide', track);
    var dots = $$('[data-u-dot]', root);
    var global = root.hasAttribute('data-u-global');
    var body = document.body;
    var current = -1, raf = 0, timer = 0;
    if (!slides.length) return;

    function apply(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (i === current) return;
      current = i;
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === i);
        s.setAttribute('aria-hidden', j === i ? 'false' : 'true');
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      var cs = getComputedStyle(slides[i]);
      var bg = cs.getPropertyValue('--u-bg').trim(), soft = cs.getPropertyValue('--u-soft').trim();
      var ink = cs.getPropertyValue('--u-ink').trim(), accent = cs.getPropertyValue('--u-accent').trim();
      root.style.setProperty('--c-bg', bg);
      root.style.setProperty('--c-ink', ink);
      root.style.setProperty('--c-accent', accent);
      if (!global) return;
      var st = body.style;
      st.setProperty('--color-bg', bg);
      st.setProperty('--color-surface', soft);
      st.setProperty('--color-text', ink);
      st.setProperty('--color-text-rgb', hexToRgb(ink));
      st.setProperty('--color-muted', 'color-mix(in srgb, ' + ink + ' 62%, ' + bg + ')');
      st.setProperty('--color-line', 'color-mix(in srgb, ' + ink + ' 14%, transparent)');
      st.setProperty('--color-accent', accent);
      st.setProperty('--color-accent-hover', accent);
      st.setProperty('--color-dark', 'color-mix(in srgb, ' + bg + ' 45%, #000)');
      body.classList.add('u-live');
      body.classList.toggle('theme-night', slides[i].getAttribute('data-dark') === 'true');
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function stop() { clearInterval(timer); timer = 0; }

    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { apply(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { root.classList.add('is-touched'); stop(); }, { passive: true });
    });
    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-u-dot]');
      if (dot) { stop(); go(parseInt(dot.getAttribute('data-u-dot'), 10)); return; }
      if (e.target.closest('[data-u-prev]')) { stop(); go(current - 1); }
      if (e.target.closest('[data-u-next]')) { stop(); go(current + 1); }
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(current - 1); }
    });
    window.addEventListener('resize', function () { track.scrollLeft = current * track.clientWidth; });

    var delay = parseInt(root.getAttribute('data-u-autoplay'), 10);
    if (delay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { go(current + 1); }, delay);
      root.addEventListener('mouseenter', stop);
    }
    apply(0);
  });

  // Shared helpers for fx.js (games, try-on, stack): add items, then show the cart
  window.UseitCart = {
    add: function (items) {
      return cartRequest(theme.routes.cartAdd || '/cart/add.js', { items: items })
        .then(function (res) {
          if (res.sections) renderDrawer(res.sections['cart-drawer']);
          return refreshCartCount();
        })
        .then(function () {
          if (document.body.dataset.cartType === 'drawer' && document.getElementById('CartDrawer')) openDrawer('CartDrawer');
          else window.location.href = theme.routes.cart || '/cart';
        })
        .catch(function (err) { toast((err && (err.description || err.message)) || theme.strings.error || 'Error'); throw err; });
    },
    toast: toast
  };

  // Browsers restoring from bfcache: keep the cart count honest
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });
})();
